import { Link } from "react-router-dom";
import Topbar from "../../layouts/topbar";
import Webmenu from "../../layouts/webmenu";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getAllInvestigation, getAllParallelInvestigation } from "../../actions/InvestigationActions";
import DataTable from "react-data-table-component";
import { useState } from "react";
import { ThreeDots } from "react-loader-spinner";
import moment from "moment/moment";
import Mobilemenu from "../../layouts/mobile-menu";
import Select from 'react-select';
import { getAllCustomer } from "../../actions/CustomerActions";
import { styleSelect } from "../../constants/customStyles";

function Investigation() {

    const dispatch = useDispatch();

    const investigations = useSelector(state => state?.investigation?.investigations?.data);
    const investigationsPagination = useSelector(state => state?.investigation?.investigations);
    const parallelInvestigations = useSelector(state => state?.investigation?.parallelInvestigations?.data);
    const parallelInvestigationsPagination = useSelector(state => state?.investigation?.parallelInvestigations);
    const customers = useSelector(state => state?.customer?.customers?.data);
    const loading = useSelector(state => state?.loading?.indexLoading);
    const user_token = localStorage.getItem('user_token');
    const user_permissions = JSON.parse(localStorage.getItem('perm'));

    // user_token)
    const [page, setPage] = useState(1);
    const [dataPage, setDataPage] = useState(1);
    const [currentRowsPerPage, setCurrentRowsPerPage] = useState(10);
    const [paginationTotalRows, setPaginationTotalRows] = useState(0);
    const [investigationsData, setInvestigationsData] = useState([]);

    // useEffect(() => {
    //     if (investigations && Object.keys(investigations).length > 0) {
    //         setInvestigationsData(investigations);
    //     }
    // }, [investigations])

    useEffect(() => {
        dispatch(getAllInvestigation(page, currentRowsPerPage, multifilters ?? "", user_token));
        dispatch(getAllParallelInvestigation(page, currentRowsPerPage, multifiltersParellel ?? "", user_token));
        dispatch(getAllCustomer(null, 999999, null));
    }, [dispatch]);

    const onChangePage = (page, currentRowsPerPage) => {
        // return () => {
            setPage(page);
        setCurrentRowsPerPage(currentRowsPerPage);
        const filterParams = multifilters.reduce((acc, filter) => {
            acc[filter.key] = filter.value;
            return acc;
        }, {});
        dispatch(getAllInvestigation(page, currentRowsPerPage, filterParams ?? "", user_token));
        // }
    };
    const onChangeParallelPage = (page) => {
        // return () => {
        dispatch(getAllParallelInvestigation(page, currentRowsPerPage, multifiltersParellel ?? "", user_token));
        // }
    };

    // useEffect(() => {
    //     if (page !== dataPage) {
    //         getData(page, currentRowsPerPage);
    //     }
    // }, [page]);

    useEffect(() => {
        // Update the paginationTotalRows prop to reflect the actual number of rows that are available
        setPaginationTotalRows(investigationsPagination.total);
    }, [investigationsPagination]);

    // paginationTotalRows)

    // useEffect(() => {
    //     // Load the data on page refresh
    //     getData(1, currentRowsPerPage);
    // }, []) // This will call the getData() function on page refresh

    // const getData = (pageNo, currentRowsPerPage) => {
    //     dispatch(getAllInvestigation(pageNo, currentRowsPerPage, "", user_token));
    //     dispatch(getAllParallelInvestigation(pageNo, currentRowsPerPage, "", user_token));
    // };

    const customStyles = {
        table: {
            style: {
                backgroundColor: 'rgb(241, 245, 248)',
            },
        },
        headRow: {
            style: {
                border: 'none !important'
            }
        },
        head: {
            style: {
                fontWeight: 'bold',
                fontSize: '14px',
                border: 'none !important',
            }
        },
        rows: {
            style: {
                minHeight: '40px',
                paddingLeft: '10px',
                backgroundColor: '#fff !important',
                borderTop: 'none !important',
                marginBottom: '10px',
                borderRadius: '30px',
                paddingRight: '5px',
                '&:not(:last-of-type)': {
                    border: 'none'
                }
            },
        },
        body: {
            style: {
                backgroundColor: 'rgb(241, 245, 248)',
            }
        },
        headCells: {
            style: {
                fontSize: '14px',
                fontWeight: '700',
                textTransform: 'uppercase',
                border: 'none !important',
                backgroundColor: 'rgb(241, 245, 248)',
                // justifyContent: 'center'
            },
        },
        cells: {
            style: {
                fontSize: '14px',
                // 'div:first-child': {
                //     overflow: 'visible !important'
                // }
                // justifyContent: 'center'
            },
        },
        pagination: {
            style: {
                backgroundColor: 'rgb(241,245,248)',
                borderTop: 'none !important',
            },
        }
    };

    const columns = [
        {
            cell: row => (
                user_permissions.some(item => item.permission_id == '4' || item.permission_id == '6') ? (
                    <div className="dropdown">
                        <button className="dropdown-toggle btn px-2 box text-gray-700 dark-text-gray-300" aria-expanded="false" data-bs-toggle="dropdown">
                            <span className="d-flex align-items-center fs-base justify-content-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-settings me-1 w-6 h-6"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>
                                Actions
                            </span>
                        </button>
                        <div className="dropdown-menu w-40 z-50">
                            <div className="dropdown-content z-50">
                            <Link to={`/investigation/invoice/${row.estimate_id}`} target="_blank" className="d-flex align-items-center fs-base py-1 text-theme-12"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-file me-1 w-6 h-6"><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path><polyline points="13 2 13 9 20 9"></polyline></svg> Print </Link>
                                {
                                    user_permissions.some(item => item.permission_id == '4') && (
                                        <Link className="d-flex align-items-center fs-base py-1" to={`/investigation/edit/${row.investigation_id}`}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-edit me-1 w-6 h-6"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>
                                            Edit
                                        </Link>
                                    )
                                }
                                {
                                    user_permissions.some(item => item.permission_id == '6') && (
                                        <Link to={`/estimate/add/${row.investigation_id}`} className="d-flex align-items-center fs-base w-24 py-1 text-theme-10">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-file me-1 w-6 h-6"><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path><polyline points="13 2 13 9 20 9"></polyline></svg>
                                            Estimate
                                        </Link>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                ) : null
            ),
        },
        {
            name: 'ID',
            selector: row => row.investigation_id,
            sortable: true,
            width: '150px'
        },
        {
            name: 'ESTIMATE ID',
            selector: row => row?.estimate?.estimate_id,
            sortable: true,
            width: '150px'
        },
        {
            name: 'JOB CARD ID',
            selector: row => row?.estimate?.job_card?.job_card_id,
            sortable: true,
            width: '150px'
        },
        {
            name: 'CUSTOMER NAME',
            selector: row => row?.customer?.name,
            sortable: true,
            // width: '30%'
        },
        {
            name: 'MOBILE',
            selector: row => row?.customer?.mobile,
            sortable: true,
        },
        {
            name: 'PLATE #',
            selector: row => row?.vehicle?.plate_number,
            sortable: true,
        },
        {
            name: 'CHASIS #',
            selector: row => row?.vehicle?.chasis_no,
            sortable: true,
        },
        {
            name: 'CREATED ON',
            selector: row => moment(row.created_at).format('YYYY-MM-DD'),
            sortable: true,
            // selector: row => row.created_at,
        },
    ];
    const parallelColumns = [
        {
            name: 'ID',
            selector: row => row.investigation_id,
            sortable: true,
        },
        {
            name: 'CUSTOMER NAME',
            selector: row => row?.customer?.name,
            sortable: true,
        },
        {
            name: 'MOBILE',
            selector: row => row?.customer?.mobile,
            sortable: true,
        },
        {
            name: 'PLATE #',
            selector: row => row?.vehicle?.plate_number,
            sortable: true,
        },
        {
            name: 'CREATED ON',
            selector: row => moment(row.created_at).format('YYYY-MM-DD'),
            sortable: true,
            // selector: row => row.created_at,
        },
    ];

    const [filter, setFilter] = useState('');

    const [filterOption, setFilterOption] = useState('');

    const [multifilters, setMultiFilters] = useState([]);
    const [multifilterOption, setMultiFilterOption] = useState([]);
    const [multifiltersParellel, setMultiFiltersParellel] = useState([]);
    const [multifilterOptionParellel, setMultiFilterOptionParellel] = useState([]);

    const filterOptions = [
        { value: 'investigation_id', label: 'Investigation #' },
        { value: 'customer_id', label: 'Customer' },
        { value: 'plate_no', label: 'Plate #' },
        { value: 'chasis_no', label: 'Chasis #' },
    ]

    const handleMultiFilter = (event) => {
        const { name, value } = event.target;
        setMultiFilters(prevFilters => {
            const updatedFilters = [...prevFilters];
            const index = updatedFilters.findIndex(filter => filter.key === name);
            if (index > -1) {
                updatedFilters[index].value = value;
            } else {
                updatedFilters.push({ key: name, value });
            }
            return updatedFilters;
        });
    };

    const handleMultiFilterDropdown = (selectedOption) => {
        setMultiFilters(prevFilters => {
            const updatedFilters = [...prevFilters];
            const index = updatedFilters.findIndex(filter => filter.key === 'customer_id');
            if (index > -1) {
                updatedFilters[index] = { key: 'customer_id', value: selectedOption.customer_id, label: selectedOption.name };
            } else {
                updatedFilters.push({ key: 'customer_id', value: selectedOption.customer_id, label: selectedOption.name });
            }
            return updatedFilters;
        });
    };
    const handleMultiFilterParellel = (event) => {
        const { name, value } = event.target;
        setMultiFiltersParellel(prevFilters => {
            const updatedFilters = [...prevFilters];
            const index = updatedFilters.findIndex(filter => filter.key === name);
            if (index > -1) {
                updatedFilters[index].value = value;
            } else {
                updatedFilters.push({ key: name, value });
            }
            return updatedFilters;
        });
    };

    const handleMultiFilterDropdownParellel = (selectedOption) => {
        setMultiFiltersParellel(prevFilters => {
            const updatedFilters = [...prevFilters];
            const index = updatedFilters.findIndex(filter => filter.key === 'customer_id');
            if (index > -1) {
                updatedFilters[index] = { key: 'customer_id', value: selectedOption.customer_id, label: selectedOption.name };
            } else {
                updatedFilters.push({ key: 'customer_id', value: selectedOption.customer_id, label: selectedOption.name });
            }
            return updatedFilters;
        });
    };

    // const handleFilter = (event) => {
    //     setFilter({
    //         ...filter,
    //         [event.target.name]: event.target.value,
    //     })
    // }
    // const handleFilters = (event) => {
    //     setFilterOption({
    //         value: event.value,
    //         label: event.label,
    //     })
    // }
    // const handleFilterDropdown = (event) => {
    //     setFilter({
    //         ...filter,
    //         'customer_id': event.customer_id,
    //         'name': event.name,
    //     })
    // }
    const handleClearFilter = () => {
        setFilter(null)
        setFilterOption(null)
        setMultiFilters([]);
        setMultiFilterOption([]);
        dispatch(getAllInvestigation(page, currentRowsPerPage, ''))
    }

    // const handleKeyPress = (event) => {
    //     if (event.key === 'Enter') {
    //         event.preventDefault();
    //         filterSearch();
    //     }
    // }

    const filterSearch = () => {
        const filterParams = multifilters.reduce((acc, filter) => {
            acc[filter.key] = filter.value;
            return acc;
        }, {});
        // dispatch(getAllInvestigation(page, currentRowsPerPage, filter ?? ''))
        dispatch(getAllInvestigation(1, currentRowsPerPage, filterParams ?? ''))
    }

    useEffect(() => {
        const updatedFilters = multifilterOption.map(option => {
            const existingFilter = multifilters.find(filter => filter.key === option.value);
            return existingFilter || { key: option.value, value: '', label: option.label };
        });

        const preservedDateFilters = multifilters.filter(filter =>
            ['date_from', 'date_to'].includes(filter.key) &&
            !multifilterOption.some(option => option.value === filter.key)
        );

        setMultiFilters([...updatedFilters, ...preservedDateFilters]);
    }, [multifilterOption]);

    useEffect(() => {
        const updatedFilters = multifilterOptionParellel.map(option => {
            const existingFilter = multifiltersParellel.find(filter => filter.key === option.value);
            return existingFilter || { key: option.value, value: '', label: option.label };
        });

        const preservedDateFilters = multifiltersParellel.filter(filter =>
            ['date_from', 'date_to'].includes(filter.key) &&
            !multifilterOptionParellel.some(option => option.value === filter.key)
        );

        setMultiFiltersParellel([...updatedFilters, ...preservedDateFilters]);
    }, [multifilterOptionParellel]);

    const [parallelFilter, setParallelFilter] = useState('');

    const handleParallelFilter = (event) => {
        setParallelFilter({
            ...parallelFilter,
            [event.target.name]: event.target.value,
        })
    }
    const handleClearParallelFilter = () => {
        setParallelFilter('')
        setMultiFiltersParellel([]);
        setMultiFilterOptionParellel([]);
        dispatch(getAllParallelInvestigation(page, currentRowsPerPage, ''))
    }

    const handleKeyPressParallel = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            parallelFilterSearch();
        }
    }

    const parallelFilterSearch = () => {
        const filterParams = multifiltersParellel.reduce((acc, filter) => {
            acc[filter.key] = filter.value;
            return acc;
        }, {});
        // dispatch(getAllParallelInvestigation(page, currentRowsPerPage, parallelFilter ?? ''))
        dispatch(getAllParallelInvestigation(page, currentRowsPerPage, filterParams ?? ''))
    }

    return (
        <span>
            <Mobilemenu />
            <div className="content-body d-flex">
                <Webmenu />
                <div className="content">
                    <Topbar />
                    {/* {
                    loading ?
                        <ThreeDots
                            height="80"
                            width="80"
                            radius="9"
                            color="#2d3748"
                            ariaLabel="three-dots-loading"
                            wrapperStyle={{ justifyContent: 'center', alignItems: 'center', height: '100%' }}
                            wrapperClassName=""
                            visible={loading}
                        /> : */}
                    <span>
                        {/* <!-- BEGIN: Data List --> */}
                        <div className="py-5">
                            <ul className="pos__tabs nav nav-pills rounded-2" role="tablist">
                                <li id="investigations-tab" className="nav-item box mx-3 flex-1" role="presentation">
                                    <button className="nav-link w-full pt-2 pb-2.5 active" data-bs-toggle="pill" data-bs-target="#investigations" type="button" role="tab" aria-controls="investigations-tab" aria-selected="true">Investigations</button>
                                </li>
                                <li id="parallelInvestigations-tab" className="nav-item box mx-3 flex-1" role="presentation">
                                    <button className="nav-link w-full pt-2 pb-2.5" data-bs-toggle="pill" data-bs-target="#parallelInvestigations" type="button" role="tab" aria-controls="parallelInvestigations-tab" aria-selected="false">Parallel Investigations</button>
                                </li>
                            </ul>
                            <div className="tab-content">
                                <div className="tab-pane fade show active" id="investigations" role="tabpanel" aria-labelledby="investigations-tab">
                                    <div className="intro-y g-col-12 px-3 mt-5 d-flex flex-wrap flex-sm-nowrap align-items-center justify-content-between mt-2">
                                        {
                                            user_permissions.some(item => item.permission_id == '3') &&
                                            <Link to="/investigation/add">
                                                <button className="btn btn-primary shadow-md me-2">Add New</button>
                                            </Link>
                                        }
                                        {/* <div className="w-full w-sm-auto mt-3 mt-sm-0 ms-sm-auto ms-md-0">
                                                <div className="w-56 position-relative text-gray-700 dark-text-gray-300">
                                                    <input type="text" className="form-control w-56 box border-white dark-border-dark-3 pe-10 placeholder-theme-13" placeholder="Search..." />
                                                    <i className="w-4 h-4 position-absolute my-auto top-0 bottom-0 me-3 end-0" data-feather="search"></i>
                                                </div>
                                            </div> */}
                                        <button class="btn btn-primary ms-auto d-flex align-items-center dark-text-theme-10" type="button"
                                            data-bs-toggle="collapse" data-bs-target="#faq-accordion-collapse-1" aria-expanded="true"
                                            aria-controls="faq-accordion-collapse-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-filter w-4 h-4 me-3"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon></svg>
                                            Filters </button>
                                    </div>
                                    <div id="faq-accordion-collapse-1" class="accordion-collapse collapse show show mt-5" aria-labelledby="faq-accordion-content-1"
                                        data-bs-parent="#faq-accordion-1">
                                        <div class="grid columns-12 gap-6 mt-5">
                                            <div class="intro-y g-col-12 g-col-lg-12">
                                                <div class="intro-y box p-5">
                                                    <div class="row">
                                                        <div className="col-lg-3 col-md-6 mt-2">
                                                            <label className="form-label font-weight-bold">Date From</label>
                                                            <input
                                                                type="date"
                                                                name="date_from"
                                                                value={multifilters.find(filter => filter.key === 'date_from')?.value || ''}
                                                                onChange={handleMultiFilter}
                                                                className="form-control w-full"
                                                            />
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 mt-2">
                                                            <label className="form-label font-weight-bold">Date To</label>
                                                            <input
                                                                type="date"
                                                                name="date_to"
                                                                value={multifilters.find(filter => filter.key === 'date_to')?.value || ''}
                                                                onChange={handleMultiFilter}
                                                                className="form-control w-full"
                                                            />
                                                        </div>
                                                        <div className="col-lg-3 col-md-4 mt-2">
                                                            <label className="form-label">Filter</label>
                                                            <Select
                                                                isMulti
                                                                styles={styleSelect}
                                                                value={multifilterOption || []}
                                                                onChange={setMultiFilterOption}
                                                                options={filterOptions}
                                                            />
                                                        </div>
                                                        {multifilters
                                                            .filter(filter => !['date_from', 'date_to'].includes(filter.key))
                                                            .map((filter, index) => (
                                                                filter.key === 'customer_id' ? (
                                                                    <div key={index} className="col-lg-3 col-md-4 mt-2">
                                                                        <label className="form-label font-weight-bold">Customer Name</label>
                                                                        <Select
                                                                            onChange={handleMultiFilterDropdown}
                                                                            value={customers && customers.find(cust => cust.customer_id === filter.value) || null}
                                                                            getOptionLabel={option => `${option.name} - ${option.mobile || 'N/A'}`}
                                                                            getOptionValue={option => option.customer_id}
                                                                            options={customers || []}
                                                                            styles={styleSelect}
                                                                        />
                                                                    </div>
                                                                ) : (
                                                                    <div key={index} className="col-lg-3 col-md-4 mt-2">
                                                                        <label className="form-label font-weight-bold">{filterOptions.find(opt => opt.value === filter.key)?.label}</label>
                                                                        <input
                                                                            type="text"
                                                                            value={filter.value}
                                                                            onChange={(event) => handleMultiFilter({ target: { name: filter.key, value: event.target.value } })}
                                                                            className="form-control w-full"
                                                                        />
                                                                    </div>
                                                                )
                                                            ))}
                                                    </div>
                                                    <div class="text-end mt-5">
                                                        <button type="submit" class="btn btn-elevated-primary w-24 me-2" onClick={() => filterSearch()}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search w-4 h-4 me-2"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
                                                            Search</button>
                                                        <button onClick={handleClearFilter} type="button" class="btn btn-elevated-danger w-24"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x w-4 h-4 me-2"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg> Clear</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="intro-y g-col-12 overflow-y-visible h-screen">
                                        <div className='mt-2 overflow-x-auto overflow-y-visible h-screen'>
                                            {/* <DataTable
                                                    className="overflow-visible"
                                                   columns={columns.map(column => ({
                                                    ...column,
                                                    cell: column.cell ? column.cell : (row) => (
                                                        <div>
                                                            {column.selector(row)}
                                                        </div>
                                                    ),
                                                }))}
                                                    data={investigations && investigations.length > 0 ? investigations : []}
                                                    striped={true}
                                                    highlightOnHover={true}
                                                    pagination={true}
                                                    customStyles={customStyles}
                                                    responsive={true}
                                                    paginationServer={true}
                                                    paginationTotalRows={paginationTotalRows}
                                                    onChangePage={(page) => onChangePage(page)}
                                                    paginationRowsPerPageOptions={[10, 20, 50, 100]}
                                                    onChangeRowsPerPage={(currentRowsPerPage, currentPage) =>
                                                        setCurrentRowsPerPage(currentRowsPerPage)
                                                    }
                                                    paginationPerPage={currentRowsPerPage}
                                                /> */}
                                            <DataTable
                                                className="overflow-lg-visible"
                                                columns={columns.map(column => ({
                                                    ...column,
                                                    cell: column.cell ? column.cell : (row) => (
                                                        <div>
                                                            {column.selector(row)}
                                                        </div>
                                                    ),
                                                }))}
                                                data={investigations && investigations.length > 0 ? investigations : []}
                                                progressPending={loading}
                                                progressComponent={<ThreeDots
                                                    height="80"
                                                    width="80"
                                                    radius="9"
                                                    color="#2d3748"
                                                    ariaLabel="three-dots-loading"
                                                    wrapperStyle={{ justifyContent: 'center', alignItems: 'center', height: '100%' }}
                                                    wrapperClassName=""
                                                    visible={loading}
                                                />}
                                                pagination
                                                paginationServer
                                                customStyles={customStyles}
                                                paginationTotalRows={paginationTotalRows}
                                                onChangeRowsPerPage={(currentRowsPerPage) => onChangePage(page, currentRowsPerPage)}
                                                onChangePage={(page) => onChangePage(page, currentRowsPerPage)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade show" id="parallelInvestigations" role="tabpanel" aria-labelledby="parallelInvestigations-tab">
                                    <div className="intro-y g-col-12 px-3 mt-5 d-flex flex-wrap flex-sm-nowrap align-items-center justify-content-between mt-2">
                                        {/* <div className="w-full w-sm-auto mt-3 mt-sm-0 ms-sm-auto ms-md-0">
                                                <div className="w-56 position-relative text-gray-700 dark-text-gray-300">
                                                    <input type="text" className="form-control w-56 box border-white dark-border-dark-3 pe-10 placeholder-theme-13" placeholder="Search..." />
                                                    <i className="w-4 h-4 position-absolute my-auto top-0 bottom-0 me-3 end-0" data-feather="search"></i>
                                                </div>
                                            </div> */}
                                        <button class="btn btn-primary ms-auto d-flex align-items-center dark-text-theme-10" type="button"
                                            data-bs-toggle="collapse" data-bs-target="#faq-accordion-collapse-1" aria-expanded="true"
                                            aria-controls="faq-accordion-collapse-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-filter w-4 h-4 me-3"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon></svg>
                                            Filters </button>
                                    </div>
                                     {/* <div id="faq-accordion-collapse-1" class="accordion-collapse collapse show mt-5" aria-labelledby="faq-accordion-content-1"
                                        data-bs-parent="#faq-accordion-1">
                                        <div class="grid columns-12 gap-6 mt-5">
                                            <div class="intro-y g-col-12 g-col-lg-12">
                                                <div class="intro-y box p-5">
                                                    <div class="row">
                                                        <div class="col-md-2">
                                                            <div>
                                                                <label for="crud-form-1" class="form-label font-weight-bold">Date From</label>
                                                                <input id="crud-form-1" type="date" onKeyPress={handleKeyPressParallel} onChange={handleParallelFilter} value={parallelFilter?.date_from} name="date_from"
                                                                    class="form-control w-full" placeholder="Enter Date From." />
                                                            </div>
                                                        </div>
                                                        <div class="col-md-2">
                                                            <div>
                                                                <label for="crud-form-1" class="form-label font-weight-bold">Date To</label>
                                                                <input id="crud-form-1" type="date" onKeyPress={handleKeyPressParallel} onChange={handleParallelFilter} value={parallelFilter?.date_to} name="date_to"
                                                                    class="form-control w-full" placeholder="Enter Date to." />
                                                            </div>
                                                        </div>
                                                        <div class="col-md-2">
                                                            <div>
                                                                <label for="crud-form-1" class="form-label font-weight-bold">Mobile No.</label>
                                                                <input id="crud-form-1" type="text" onKeyPress={handleKeyPressParallel} onChange={handleParallelFilter} value={parallelFilter?.customerMobile} name="customerMobile"
                                                                    class="form-control w-full" placeholder="Enter Mobile No." />
                                                            </div>
                                                        </div>
                                                        <div class="col-md-3">
                                                            <div>
                                                                <label for="crud-form-1" class="form-label font-weight-bold">Customer Name</label>
                                                                <input id="crud-form-1" type="text" onKeyPress={handleKeyPressParallel} onChange={handleParallelFilter} value={parallelFilter?.customerName} name="customerName"
                                                                    class="form-control w-full " placeholder="Enter Customer Name" />
                                                            </div>
                                                        </div>
                                                        <div class="col-md-3">
                                                            <div>
                                                                <label for="crud-form-1" class="form-label font-weight-bold">Plate #</label>
                                                                <input id="crud-form-1" type="text" onKeyPress={handleKeyPressParallel} onChange={handleParallelFilter} value={parallelFilter?.vehiclePlateNo} name="vehiclePlateNo"
                                                                    class="form-control w-full" placeholder="Enter Plate No." />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="text-end mt-5">
                                                        <button type="submit" class="btn btn-elevated-primary w-24 me-2" onClick={() => parallelFilterSearch()}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search w-4 h-4 me-2"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
                                                            Search</button>
                                                        <button onClick={handleClearParallelFilter} type="button" class="btn btn-elevated-danger w-24"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x w-4 h-4 me-2"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg> Clear</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                                    <div id="faq-accordion-collapse-1" class="accordion-collapse collapse show show mt-5" aria-labelledby="faq-accordion-content-1"
                                        data-bs-parent="#faq-accordion-1">
                                        <div class="grid columns-12 gap-6 mt-5">
                                            <div class="intro-y g-col-12 g-col-lg-12">
                                                <div class="intro-y box p-5">
                                                    <div class="row">
                                                        <div className="col-lg-3 col-md-6 mt-2">
                                                            <label className="form-label font-weight-bold">Date From</label>
                                                            <input
                                                                type="date"
                                                                name="date_from"
                                                                value={multifiltersParellel.find(filter => filter.key === 'date_from')?.value || ''}
                                                                onChange={handleMultiFilterParellel}
                                                                className="form-control w-full"
                                                            />
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 mt-2">
                                                            <label className="form-label font-weight-bold">Date To</label>
                                                            <input
                                                                type="date"
                                                                name="date_to"
                                                                value={multifiltersParellel.find(filter => filter.key === 'date_to')?.value || ''}
                                                                onChange={handleMultiFilterParellel}
                                                                className="form-control w-full"
                                                            />
                                                        </div>
                                                        <div className="col-lg-3 col-md-4 mt-2">
                                                            <label className="form-label">Filter</label>
                                                            <Select
                                                                isMulti
                                                                styles={styleSelect}
                                                                value={multifilterOptionParellel || []}
                                                                onChange={setMultiFilterOptionParellel}
                                                                options={filterOptions}
                                                            />
                                                        </div>
                                                        {multifiltersParellel
                                                            .filter(filter => !['date_from', 'date_to'].includes(filter.key))
                                                            .map((filter, index) => (
                                                                filter.key === 'customer_id' ? (
                                                                    <div key={index} className="col-lg-3 col-md-4 mt-2">
                                                                        <label className="form-label font-weight-bold">Customer Name</label>
                                                                        <Select
                                                                            onChange={handleMultiFilterDropdownParellel}
                                                                            value={{ customer_id: filter.value, name: filter.label }}
                                                                            getOptionLabel={option => option.name}
                                                                            getOptionValue={option => option.customer_id}
                                                                            options={customers || []}
                                                                            styles={styleSelect}
                                                                        />
                                                                    </div>
                                                                ) : (
                                                                    <div key={index} className="col-lg-3 col-md-4 mt-2">
                                                                        <label className="form-label font-weight-bold">{filterOptions.find(opt => opt.value === filter.key)?.label}</label>
                                                                        <input
                                                                            type="text"
                                                                            value={filter.value}
                                                                            onChange={(event) => handleMultiFilterParellel({ target: { name: filter.key, value: event.target.value } })}
                                                                            className="form-control w-full"
                                                                        />
                                                                    </div>
                                                                )
                                                            ))}
                                                    </div>
                                                    <div class="text-end mt-5">
                                                        <button type="submit" class="btn btn-elevated-primary w-24 me-2" onClick={() => parallelFilterSearch()}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search w-4 h-4 me-2"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
                                                            Search</button>
                                                        <button onClick={handleClearParallelFilter} type="button" class="btn btn-elevated-danger w-24"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x w-4 h-4 me-2"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg> Clear</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="intro-y g-col-12">
                                        <div className='mt-2'>
                                            <DataTable
                                                className="overflow-lg-visible"
                                                columns={parallelColumns}
                                                data={parallelInvestigations && parallelInvestigations.length > 0 ? parallelInvestigations : []}
                                                progressPending={loading}
                                                progressComponent={<ThreeDots
                                                    height="80"
                                                    width="80"
                                                    radius="9"
                                                    color="#2d3748"
                                                    ariaLabel="three-dots-loading"
                                                    wrapperStyle={{ justifyContent: 'center', alignItems: 'center', height: '100%' }}
                                                    wrapperClassName=""
                                                    visible={loading}
                                                />}
                                                pagination
                                                paginationServer
                                                customStyles={customStyles}
                                                paginationTotalRows={paginationTotalRows}
                                                onChangeRowsPerPage={(currentRowsPerPage) => setCurrentRowsPerPage(currentRowsPerPage)}
                                                onChangePage={(page) => onChangeParallelPage(page)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <!-- END: Data List --> */}
                        </div>
                    </span >
                    {/* } */}
                </div >
            </div >
        </span>
    )
}
export default Investigation;